import type { TrialStatus } from '../actions/subscription/getTrialStatus';

/**
 * Pure derivation of "can this user dispatch jobs?".
 *
 * Trust order:
 *   1. Live `/subscription/trial-status` (when it has loaded) — the backend
 *      reads the live DynamoDB row and is the source of truth. This means
 *      flipping a user's subscription status to ACTIVE / TRIALING in AWS
 *      unblocks them on next page load even with a stale JWT.
 *   2. Fall back to JWT `custom:paid` (`user.isApproved`) only when the live
 *      endpoint hasn't responded yet. A failed fetch leaves trialState=null
 *      so this fallback also handles transient backend hiccups without
 *      kicking paid users out.
 *
 * Lives in its own file (no Amplify imports) so vitest can exercise the
 * truth-table without dragging in the full AuthContext module graph.
 */
export function deriveCanUseTools(
  trialState: TrialStatus | null,
  user: { isApproved: boolean } | null,
): boolean {
  if (trialState !== null) {
    if (trialState.blocked) return false;
    return trialState.status === 'trialing' || trialState.status === 'paid';
  }
  return !!user?.isApproved;
}
